module.exports = __webpack_public_path__ + "static/media/bgmainslider.f4b038d8.webp";